// extracted by mini-css-extract-plugin
export var cardLayout = "_5h-1";
export var paginationContainer = "_5h-0";